import { Link } from "react-router-dom";
import { CONTACT, SOCIAL, FOOTER_BADGES } from "../data/products.js";

// Brand marks for the "Follow us on" row, keyed by SOCIAL id. Kept here rather
// than in products.js so that module stays plain data.
const SOCIAL_PATHS = {
  facebook:
    "M9.101 23.691v-7.98H6.627v-3.667h2.474v-1.58c0-4.085 1.848-5.978 5.858-5.978.401 0 .955.042 1.468.103a8.68 8.68 0 011.141.195v3.325a8.623 8.623 0 00-.653-.036 26.805 26.805 0 00-.733-.009c-.707 0-1.259.096-1.675.309a1.686 1.686 0 00-.679.622c-.258.42-.374.995-.374 1.752v1.297h3.919l-.386 2.103-.287 1.564h-3.246v8.245C19.396 23.238 24 18.179 24 12.044c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.628 3.874 10.35 9.101 11.647z",
  instagram:
    "M12 0C8.74 0 8.333.015 7.053.072 5.775.132 4.905.333 4.14.63c-.789.306-1.459.717-2.126 1.384S.935 3.35.63 4.14C.333 4.905.131 5.775.072 7.053.012 8.333 0 8.74 0 12s.015 3.667.072 4.947c.06 1.277.261 2.148.558 2.913.306.788.717 1.459 1.384 2.126.667.666 1.336 1.079 2.126 1.384.766.296 1.636.499 2.913.558C8.333 23.988 8.74 24 12 24s3.667-.015 4.947-.072c1.277-.06 2.148-.262 2.913-.558.788-.306 1.459-.718 2.126-1.384.666-.667 1.079-1.335 1.384-2.126.296-.765.499-1.636.558-2.913.06-1.28.072-1.687.072-4.947s-.015-3.667-.072-4.947c-.06-1.277-.262-2.149-.558-2.913-.306-.789-.718-1.459-1.384-2.126C21.319 1.347 20.651.935 19.86.63c-.765-.297-1.636-.499-2.913-.558C15.667.012 15.26 0 12 0zm0 2.16c3.203 0 3.585.016 4.85.071 1.17.055 1.805.249 2.227.415.562.217.96.477 1.382.899.419.42.679.819.896 1.381.164.422.36 1.057.413 2.227.057 1.266.07 1.646.07 4.85s-.015 3.585-.074 4.85c-.061 1.17-.256 1.805-.421 2.227-.224.562-.479.96-.899 1.382-.419.419-.824.679-1.38.896-.42.164-1.065.36-2.235.413-1.274.057-1.649.07-4.859.07-3.211 0-3.586-.015-4.859-.074-1.171-.061-1.816-.256-2.236-.421-.569-.224-.96-.479-1.379-.899-.421-.419-.69-.824-.9-1.38-.165-.42-.359-1.065-.42-2.235-.045-1.26-.061-1.649-.061-4.844 0-3.196.016-3.586.061-4.861.061-1.17.255-1.814.42-2.234.21-.57.479-.96.9-1.381.419-.419.81-.689 1.379-.898.42-.166 1.051-.361 2.221-.421 1.275-.045 1.65-.06 4.859-.06zm0 3.678a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm7.846-10.405a1.44 1.44 0 11-2.88 0 1.44 1.44 0 012.88 0z",
  youtube:
    "M23.498 6.186a3.016 3.016 0 00-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 00.502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 002.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 002.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z",
  x: "M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z",
  whatsapp:
    "M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.435 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z",
};

// Legal strip. Privacy/terms/shipping/refunds have no page in the app yet —
// point each at its route once the page exists.
const LEGAL_LINKS = [
  { label: "Privacy policy", href: "#" },
  { label: "Terms of service", href: "#" },
  { label: "Shipping & delivery", href: "#" },
  { label: "Refunds & returns", href: "#" },
  { label: "Contact us", href: "/#contact" },
];

export default function Footer() {
  return (
    <footer className="ftr">
      <div className="container ftr__top">
        <div className="ftr__brand">
          <p className="ftr__logo">
            Rimm<span className="hdr__logo-o">o</span>n<strong>Farm</strong>
          </p>
          <p>Farm-fresh mangoes, eggs, milk &amp; live chickens — direct from our Andhra farm.</p>
        </div>
        <div className="ftr__col">
          <h4>Shop</h4>
          <Link to="/products">All products</Link>
          <Link to="/products?category=eggs">Eggs &amp; milk</Link>
          <Link to="/products?category=poultry">Live chickens</Link>
        </div>
        <div className="ftr__col">
          <h4>Rimmon Farm</h4>
          <a href="/#about">About us</a>
          <a href="/#contact">Contact</a>
        </div>
        <div className="ftr__col">
          <h4>Contact</h4>
          <a href={`tel:${CONTACT.phoneTel}`}>{CONTACT.phoneDisplay}</a>
          <a href={`mailto:${CONTACT.email}`}>{CONTACT.email}</a>
          <span className="ftr__loc">{CONTACT.location}</span>
        </div>
      </div>

      <div className="container ftr__util">
        <ul className="ftr__badges">
          {FOOTER_BADGES.map((b) => (
            <li key={b.id} className="ftr__badge">
              <span aria-hidden="true">{b.icon}</span>
              {b.label}
            </li>
          ))}
        </ul>

        <div className="ftr__social">
          <span className="ftr__social-label">Follow us on</span>
          {SOCIAL.map((s) => {
            // A handle still on "#" renders dimmed and inert rather than
            // opening a blank tab. It lights up the moment products.js
            // gets the real profile URL.
            const pending = s.href === "#";
            return (
              <a
                key={s.id}
                className={`ftr__social-ico${pending ? " ftr__social-ico--soon" : ""}`}
                href={s.href}
                {...(pending
                  ? { "aria-disabled": "true", tabIndex: -1, onClick: (e) => e.preventDefault() }
                  : { target: "_blank", rel: "noopener noreferrer" })}
                aria-label={pending ? `${s.label} — coming soon` : s.label}
                title={pending ? `${s.label} — coming soon` : s.label}
              >
                <svg viewBox="0 0 24 24" width="15" height="15" fill="currentColor" aria-hidden="true">
                  <path d={SOCIAL_PATHS[s.id]} />
                </svg>
              </a>
            );
          })}
        </div>

        <button
          type="button"
          className="ftr__totop"
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
        >
          Back to top
          <svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
            <path d="M12 19V5M5 12l7-7 7 7" />
          </svg>
        </button>
      </div>

      <div className="ftr__legal">
        <div className="container ftr__legal-inner">
          <nav className="ftr__legal-links" aria-label="Legal">
            {LEGAL_LINKS.map((l) => (
              <a key={l.label} href={l.href}>{l.label}</a>
            ))}
          </nav>
          <p className="ftr__copy">© 2026 Rimmon Farm. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}
